import { FC } from 'react'
import {
  IconEllipsisVertical,
  Button,
  GreyGrey70
} from '@sequencehq/core-components'
import { NodeTimeline } from 'Automations/components'

export const CollapsibleToggleItem: FC<{
  isExpanded: boolean
  onToggle: () => void
  'data-testid': string
}> = ({ isExpanded, onToggle, 'data-testid': dataTestId }) => {
  return (
    <NodeTimeline.Item
      icon={<IconEllipsisVertical />}
      showStem
      iconPositionOffset={{
        y: '8px'
      }}
    >
      <NodeTimeline.Title>
        <Button
          data-testid={dataTestId}
          variant="ghost"
          style={{ width: 'fit-content' }}
          onClick={onToggle}
          color={GreyGrey70}
        >
          {isExpanded ? 'Hide all' : 'Show all'}
        </Button>
      </NodeTimeline.Title>
    </NodeTimeline.Item>
  )
}
